import { CostAssignmentType, CostType } from '@dokucoach/invoicing-types';

const costTypeOrder: CostType[] = [
  CostType.CARE,
  CostType.ACCOMMODATION,
  CostType.LODGING,
  CostType.INVESTMENT,
  CostType.TRAINING_LEVY,
  CostType.SURCHARGE_43B,
  CostType.SURCHARGE_84_9,
  CostType.OPTIONAL_SERVICE,
  CostType.CARE_AIDS,
  CostType.TRAVEL_EXPENSES,
  CostType.OTHER,
];

function costTypeToRank(costType: CostType): number {
  const index = costTypeOrder.indexOf(costType);
  return index >= 0 ? index : 100;
}

export function sortInvoiceItems<T extends { costType: CostType }>(invoiceItems: T[]): T[] {
  return invoiceItems
    .slice()
    .sort((a, b) => costTypeToRank(a.costType) - costTypeToRank(b.costType));
}

const costAssignmentTypeOrder: CostAssignmentType[] = [
  CostAssignmentType.BENEFIT_AMOUNT,
  CostAssignmentType.SUPPLEMENT_43C,
  CostAssignmentType.SURCHARGE_43B,
  CostAssignmentType.SURCHARGE_84_9,
  CostAssignmentType.SOCIAL_ASSISTANCE,
  CostAssignmentType.NURSING_HOME_ALLOWANCE,
  CostAssignmentType.MONTHLY_INCOMING_SUPPORT,
];

function costAssignmentTypeToRank(costAssignmentType: CostAssignmentType): number {
  const index = costAssignmentTypeOrder.indexOf(costAssignmentType);
  return index >= 0 ? index : 100;
}

export function sortInvoiceCostAssignments<T extends { costAssignmentType: CostAssignmentType }>(
  costAssignments: T[],
): T[] {
  return costAssignments
    .slice()
    .sort(
      (a, b) =>
        costAssignmentTypeToRank(a.costAssignmentType) -
        costAssignmentTypeToRank(b.costAssignmentType),
    );
}
